var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"message-fade"}},[(_vm.visible)?_c('div',{class:[
      'message',
      `message--${_vm.type}`,
      _vm.center ? 'is-center' : ''
    ],style:(_vm.positionStyle)},[_c('i',{class:_vm.iconClass}),_c('p',{staticClass:"message__content"},[_vm._v(_vm._s(_vm.message))]),(_vm.showClose)?_c('i',{staticClass:"message__closeBtn",on:{"click":_vm.close}},[_vm._v("×")]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }